import { Box } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import ImageInput from "../../../components/imageInput";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextFieldCompnent from "../../../components/textFieldComponent";
import MultipleSelectComponent from "../../../components/multipleSelectComponent";
import RadioButtonComponent from "../../../components/radioButtonComponent";
import {
  getVariations,
  selectAllVariations,
} from "../../../features/variationSlice";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import ButtonComponent from "../../../components/ButtonComponent";
import { useTranslation } from "react-i18next";

const IngredientForm = ({ buttonText, handleFormSubmit, initialValues, previewImage, setPreviewImage, loading, image, isDialog }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { restaurantId } = useRestaurant();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const variations = useSelector(selectAllVariations);

  const ingrediantSchema = yup.object().shape({
    name: yup.string().required("Nom est requis"),
    price: yup
      .number()
      .required("Le prix est requis")
      .min(0, "La prix minimal est 0"),
    suppPrice: yup
      .number()
      .required("Le prix est requis")
      .min(0, "La prix minimal est 0"),
    outOfStock: yup.boolean(),
    visible: yup.boolean(),
  });

  useEffect(() => {
    dispatch(getVariations(restaurantId));
  }, [dispatch, restaurantId]);

  return (
    <Formik
      onSubmit={handleFormSubmit}
      initialValues={initialValues}
      validationSchema={ingrediantSchema}
    >
      {({
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
      }) => (
        <form onSubmit={handleSubmit}>
          <Box
            display="grid"
            gap="16px"
            gridTemplateColumns="repeat(6, minmax(0, 1fr))"
            sx={{
              "& > div": { gridColumn: isNonMobile ? undefined : "span 6" },
            }}
          >
            <TextFieldCompnent
              type="text"
              label={t("fields.name")}
              change={handleChange}
              value={values.name}
              name="name"
              blur={handleBlur}
              touched={touched.name}
              error={errors.name}
              colum={isDialog ? "span 6" : "span 3"}
              row="1 / span 1"
              required
            />
            <TextFieldCompnent
              type="number"
              label={t("fields.price")}
              change={handleChange}
              value={values.price}
              name="price"
              blur={handleBlur}
              touched={touched.price}
              error={errors.price}
              colum={isDialog ? "span 6" : "span 3"}
              row="2 / span 1"
              num={0}
              required
            />
            <TextFieldCompnent
              type="number"
              label={t("fields.extraPrice")}
              change={handleChange}
              value={values.suppPrice}
              name="suppPrice"
              blur={handleBlur}
              touched={touched.suppPrice}
              error={errors.suppPrice}
              colum={isDialog ? "span 6" : "span 3"}
              row="3 / span 1"
              num={0}
              required
            />
            <MultipleSelectComponent
              name="variations"
              label={t("fields.variations")}
              gridColumn={isDialog ? "span 6" : "span 3"}
              gridRow="8 / span 1"
              items={variations}
              value={values.variations.map((v) => v._id)}
              change={(e) => {
                const selectedVariations = e.target.value.map(
                  (variationId) => ({
                    _id: variationId,
                    price:
                      values.variations.find((v) => v._id === variationId)
                        ?.price || 0,
                  })
                );
                handleChange({
                  target: {
                    name: "variations",
                    value: selectedVariations,
                  },
                });
              }}
            />
            {values.variations.map((variation, index) => (
              <TextFieldCompnent
                key={variation._id}
                type="number"
                label={t("fields.priceFor", {
                  name: variations.find((v) => v._id === variation._id)?.name || "",
                })}
                change={(e) => {
                  const newVariations = values.variations.map((v) =>
                    v._id === variation._id
                      ? { ...v, price: Number(e.target.value) }
                      : v
                  );
                  handleChange({
                    target: {
                      name: "variations",
                      value: newVariations,
                    },
                  });
                }}
                value={variation.price}
                name={`variation-${variation.variation}-price`}
                blur={handleBlur}
                colum="span 2"
                row={`${9 + index} / span 1`}
                num={0}
              />
            ))}
            <ImageInput
              row="5 / span 1"
              previewImage={previewImage}
              setPreviewImage={setPreviewImage}
              image={image}
              mediaTargetType="Ingrediant"
            />
            <RadioButtonComponent
              change={handleChange}
              colum={isDialog ? "span 6" : "span 3"}
              row="6 / span 1"
              name="outOfStock"
              radioText1={t("common.no")}
              radioText2={t("common.yes")}
              radioValue1={false}
              radioValue2={true}
              text={t("fields.outOfStock")}
              value={values.outOfStock}
            />
            <RadioButtonComponent
              change={handleChange}
              colum={isDialog ? "span 6" : "span 3"}
              row="7 / span 1"
              name="visible"
              radioText1={t("common.no")}
              radioText2={t("common.yes")}
              radioValue1={false}
              radioValue2={true}
              text={t("fields.showItem")}
              value={values.visible}
            />
          </Box>
          <ButtonComponent text={buttonText} loading={loading} />
        </form>
      )}
    </Formik>
  );
};

export default IngredientForm;
